<template>
    <div style="height: 100%;width: 100%">
        <div class="student-top">

            <div class="scroll-wrap" :style="{top: activeIndex * -1.1 + 'rem'}" :class="{show}">
                <div class="student-top-content" v-for="(item,index) in orders" :key="index">
                    <div v-if="item &&item.user" style="margin-right: 6px">{{ item.user.name }}</div>
                   <span v-if="item">
                        {{ item.purchase_at |parseTime }}
                   </span>
                    出单
                    <div style="color: #ecb950;font-style: italic;margin-left: 4px" v-if="item">¥{{ item.amount_cny }}元</div>
                </div>
            </div>

        </div>
        <div class="student-content">
            <ChartItem ref="chart"></ChartItem>
        </div>
    </div>
</template>

<script>
import ChartItem from "@/components/chart-item";


export default {
	name: "student-statistics",
	components: {ChartItem},
	data() {
		const width = document.body.clientWidth
		let is_w = width / 1920;is_w=is_w>1?1:is_w
		return {

			el: null,
			show: true,
			orders: [],
			activeIndex: 0,
			config: {
				grid: {
					top: '12%',
					left:12/is_w+'%',
					bottom: '18%',
				},
				xAxis: {
					data: 'value',
					axisLabel: {
						formatter: '{value}',
						style: {


							textBaseline: 'top',
							fill: '#cdcac3',
						}
					},
					min: 0,
					max: 790,
					interval: 200,
					axisLine: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					},
					nameTextStyle: {
						fill: '#fff',
						fontSize: is_w*12
					},
					axisTick: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					}
				},
				yAxis: [

					{

						data: ['张三', '李四', '王五', '赵六', '郑七'],
						axisLine: {
							style: {
								stroke: 'rgba(0,0,0,0)',
								lineWidth: 1
							}
						},
						splitLine: {
							show: false
						},
						axisLabel: {
							formatter: '{value}',
							style: {
								fill: '#cdcac3',
							}
						},
						nameTextStyle: {
							fill: '#fff',
							fontSize: is_w*12
						},
						axisTick: {
							show: false
						}
					},

				],
				series: [

					{
						name: '订单数',

						data: [
							775, 525, 490, 730, 345, 365, 688

						],
						label: {
							show: true,
							position: 'top',
							offset: [22, 0],
							formatter: '¥{value}',
							style: {
								fill: '#cdcac3',
								fontSize: is_w*12
							}
						},

						type: 'bar',
						barWidth: '50%',
						gradient: {
							//color: ['#e4ac3e', '#3b3734'],
							color: ['#e4ac3e', 'rgba(247,191,80,0.4)'],
						},
						animationCurve: 'easeOutBack'
					},

				]
			}
		}
	},
	filters: {
		parseTime(time) {
			let date = new Date(time);
			if (date === 'Invalid Date') {
				date = new Date()
			}
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			month = month < 10 ? '0' + month : month
			let day = date.getDate();
			day = day < 10 ? '0' + day : day
			let hour = date.getHours();
			hour = hour < 10 ? '0' + hour : hour
			let minute = date.getMinutes();
			minute = minute < 10 ? '0' + minute : minute
			return ` ${year}/${month}/${day} ${hour}:${minute} `
		}
	},
	methods: {
		handleScroll() {
			this.activeIndex++

			if (this.activeIndex > this.orders.length - 1) {
				this.show = false
				this.activeIndex = 0
				setTimeout(() => {
					this.show = true
				}, 600)
			}
			const item = this.orders[this.activeIndex]
			if (item &&item.user && item.user.name) {
				const text = `${item.user.name}${item.purchase_at}出单人民币${item.amount_cny}元`
				//this.speakText(text)
			}

		},
		setConfig(option = {}) {
			let config = {...this.config, ...option}

			if (this.el) {
				this.el.setConfig(config)
			} else {
				this.el = this.$refs.chart
				this.el.setConfig(config)
			}
		},
		setOrders(orders) {
			this.show = false
			this.activeIndex = 0
			setTimeout(() => {
				this.show = true
			}, 600)
			this.orders = orders
			this.orders.push(orders[0])
		},
		speakText(text) {
			// 获取文本输入框的内容
			if (text.trim() === '') return; // 如果文本为空，则不执行
			const utterance = new SpeechSynthesisUtterance(text); // 创建语音合成实例
			utterance.lang = 'zh-CN'; // 设置语言为中文
			utterance.volume = 1;      // 设置音量（0 到 1）
			utterance.rate = 1;        // 设置语速（0.1 到 10）
			utterance.pitch = 1;       // 设置音调（0 到 2）
			window.speechSynthesis.speak(utterance); // 播放语音

		}
	},
	mounted() {
		setInterval(() => {
			this.handleScroll()
		}, 2000)
	}
}
</script>

<style scoped lang="less">
.student-top {
  width: 96%;
  height: 1.1rem;
  margin: 0 auto;
  top: 10px;
  overflow: hidden;
  background-image: url("../assets/images/student-bg1.png");
  background-size: 100% 100%;
  position: relative;

  .scroll-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

  }

  .show {
    transition: top 0.5s ease-in;
  }

  .student-top-content {
    width: 100%;
    height: 1.1rem;
    display: flex;
    color: white;
    align-items: center;
    padding-left: 1.55rem;
    font-size: .36rem;
    line-height: .36rem;
    transition: all 1s ease-in;
  }
}

.student-content {
  position: relative;
  width: 100%;
  height: calc(100% - 1.26rem);
}
@media screen  and (max-width: 3000px) {
  .student-top .student-top-content {
    font-size: .32rem;
    line-height: .32rem;
  }


}
</style>
